import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

const getResourcesState = (state: RootState) => state.resources;

export const getResourcesDataSelector = createSelector(
  [getResourcesState],
  (resources) => resources?.resourcesData,
);

export const getResourceStatusSelector = createSelector(
  [getResourcesState],
  (resources) => resources?.resourceStatus,
);

export const getResourceErrorMessageSelector = createSelector(
  [getResourcesState],
  (resources) => resources?.errorMessage,
);
